module.exports = "data:image/gif;base64,R0lGODlhFAASAKIAAICw///ooOBIIMDAwICAgAAAAP///wAAACH5BAEAAAYALAAAAAAUABIAAANPaLrc/tCVSYe9mBXBRTGDEoJS55HoqFET5qoKIcup+IwDO9mNWwTAQMHVE/2CH1QRpEvCRK6ZjMjA8ZpLq6EA6AKS0JeF6wXztNiIer1OAAA7"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/procedure.gif
// module id = kcav
// module chunks = 1